export const dataSkills = [
  {
    id: 1,
    skill:
      "Develop websites, web and mobile applications from scratch, launch, and maintain them",
  },
  {
    id: 2,
    skill: "Proficient in front and back end technologies",
  },
  { id: 3, skill: "Design, develop and maintain database applications" },
  {
    id: 4,
    skill: "Ensure code standards, program integrity, and security of data",
  },
  { id: 5, skill: "Ensure mobile/responsive design" },
  {
    id: 6,
    skill: "Develop user interfaces that are user- friendly and efficient",
  },
  {
    id: 7,
    skill: "Identify and troubleshoot technical issues and provide resolutions",
  },
  {
    id: 8,
    skill:
      "Working closely with clients to gather requirements and ensure their satisfaction",
  },
  {
    id: 9,
    skill:
      "Strong drive to push boundaries, embrace new challenges, and constantly learn",
  },
  { id: 10, 
    skill: "Team-oriented and open to collaboration" 
},
{id: 11,
skill: "Efficient time management"
}
];